import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FlipitemtabService } from '@services/flipitemtab.service';
import { ItemService } from '@services/item.service';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';
import { ScoringTypeEnum } from 'src/app/shared/config/questions.config';
import { customValidationService } from 'src/app/shared/custom.validator';
import { CollectionService } from '@services/collection.service';
@Component({
  selector: 'app-item-basic-details',
  templateUrl: './item-basic-details.component.html',
  styleUrls: ['./item-basic-details.component.scss'],
})
export class ItemBasicDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() itemBasicDetails: any;
  @Input() isPublished: any;
  isNewItem = true;
  collectionId: any;
  itemBankName: any;
  itemDescription: any;
  action = '';
  duplicateDataFlag = false;
  basicDetailsForm: FormGroup;
  isPublishedItem = false;
  globalcollectionid: any;
  globalcollectionuuid: any;
  @Input() testId: any;
  display = false;
  itemUuid: any;
  itemsSubscription: Subscription;
  newItemSubscription: Subscription;
  styleGroupSubscription$: Subscription;
  itemDetails: any;
  @Input() itemuuuid: any;
  ScoringTypeEnum = ScoringTypeEnum;
  scoringTypeId: any;
  isStyleGroupShow = false;
  scoringTypes: any;

  styleGroupData: any;
  selectedScoringType: any;
  selectedstyleGroup: any;
  isStyleGroupDisabed: any = null;
  itemuuidData$: Subscription;
  evaluationMode: number;

  constructor(
    private itemService: ItemService,
    private testService: TestService,
    private actRoute: ActivatedRoute,
    private messageService: MessageService,
    private flipitemtabService: FlipitemtabService,
    private router: Router,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public CollectionService: CollectionService,
    public dialogRef: MatDialogRef<ItemBasicDetailsComponent>,
  ) {
    this.isStyleGroupShow = false;
    this.collectionId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    this.scoringTypeId = JSON.parse(sessionStorage.getItem('scoringTypeId'));
    const userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.evaluationMode = userData.evaluationmode;

    if(this.itemuuidData$){this.itemuuidData$.unsubscribe();}
    this.itemuuidData$ = this.itemService.itemdata.subscribe((resData) => {
      this.itemUuid = resData;
    });
    this.itemService.updateStatus.subscribe((data) => {
    });
    if (this.itemBasicDetails) {
      this.isPublishedItem = this.itemBasicDetails.isPublished;
    }

    this.itemService.getScoringTypes().subscribe((scoringTypes) => {
      if(this.evaluationMode === 1){
        this.scoringTypes = scoringTypes.items.filter(type => type.scoringTypeId === 1 || type.scoringTypeId === 2);
      } else {
        this.scoringTypes = scoringTypes.items;
      }
    });
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('TestId')) {
      this.display = true;
    }
    this.globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );

    this.globalcollectionuuid = JSON.parse(
      sessionStorage.getItem('defaultcollectionuuid')
    );

    if (this.itemBasicDetails) {
      this.isPublished = this.itemBasicDetails.isPublished;
    }

    this.basicDetailsForm = new FormGroup({
      itemTitle: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]
      ),
      itemDes: new FormControl('',
        [
          Validators.minLength(1),
          Validators.maxLength(480),
        ]
      ),
      scoringTypeId: new FormControl(this.scoringTypeId, [Validators.required]),
      styleGroupId: new FormControl("")
    });

    console.log(this.basicDetailsForm)
    this.selectedScoringType = this.scoringTypeId;
    if (this.itemuuuid != undefined) {
      this.itemService.styleGroupList.subscribe(d => {this.styleGroupData = d;});
      this.itemService.getItemDetails(this.itemUuid).subscribe((data) => {
        this.itemDetails = data.data;
        this.basicDetailsForm.setValue({
          itemTitle: this.itemDetails?.itemBankName,
          itemDes: this.itemDetails?.itemDescription,
          scoringTypeId: this.itemDetails?.scoringTypeId, //this.itemDetails?.scoringTypeId,  // set data from api
          styleGroupId: this.itemDetails?.stylegroupid,
        });
        this.isStyleGroupDisabed = this.itemDetails?.questions.length != 0 ? true : null;
        this.selectedScoringType = this.itemDetails?.scoringTypeId;
        if (this.itemDetails?.stylegroupid != 0) this.selectedstyleGroup = this.itemDetails?.stylegroupid;
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    } else {
      this.itemService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
        this.styleGroupData = data.data;
      });
    }

    if (this.scoringTypeId != null) {
      if (this.scoringTypeId === 3) this.changeScoringType(this.scoringTypeId);
    }
  }

  changeScoringType(event) {
    this.isStyleGroupShow = parseInt(event) == 3 ? true : false;
    const styleGroupId = this.basicDetailsForm.get('styleGroupId');

    if (parseInt(event) != 0) {
      if (parseInt(event) === 3) {
        styleGroupId.setValidators([Validators.required]);
      } else {
        styleGroupId.setValue('');
        styleGroupId.setValidators(null);
        styleGroupId.markAsUntouched();
      }
      styleGroupId.updateValueAndValidity();
    }
  }

  closeDialog() {
    this.dialogRef.close("noitem");
  }

  gotoTestItems() {
    this.testId = sessionStorage.getItem('TestId');
    this.router.navigate([
      '/collections',
      this.globalcollectionuuid,
      'tests',
      this.testId,
    ]);
    sessionStorage.removeItem('TestId');
  }

  // This function used for validation purpose
  get f() {
    return this.basicDetailsForm.controls;
  }
  ngOnChanges(): void {
    if (this.itemBasicDetails) {
      this.isNewItem = false;
    }

    if (this.itemBasicDetails) {
      this.isPublishedItem = this.itemBasicDetails.isPublished;
    }
  }

  saveBasicItemDetails(): void {
    if (this.isNewItem == true) {
      if (this.itemDescription != null && this.itemDescription != undefined) {
        this.itemDescription = this.itemDescription.trim();
      }

      this.newItemSubscription = this.itemService
        .addNewItem(
          this.globalcollectionuuid,
          this.basicDetailsForm?.value?.itemTitle,
          this.basicDetailsForm.value?.itemDes,
          this.basicDetailsForm.value?.scoringTypeId,
          this.basicDetailsForm.value?.styleGroupId
        )
        .subscribe(
          (resData) => {
            this.itemService.getItem(this.globalcollectionuuid).subscribe(
              (resData) => {
                this.itemService.createdGetItem(resData);

              }, (error: any) => {
                this.webErrorService.handleAPIErrors(error);
              });
            if (resData?.data?.itemBankId) {
              sessionStorage.setItem("scoringTypeId", resData?.data?.scoringtypeid);
              this.itemService.ScoringTypeId.next(resData?.data?.scoringtypeid);
              this.itemService.updateItemBankName(resData?.data?.itemBankName);
              this.notificationService.success(resData.message); // This line used to display message
              this.dialogRef.close(resData);
            }
          },
          (error) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
            // This line used to display error message
            this.basicDetailsForm.controls['itemTitle'].reset()

          }
        );
    } else {
      if (this.basicDetailsForm.value.itemDes != null && this.basicDetailsForm.value.itemDes != undefined) {
        this.basicDetailsForm.value.itemDes =
          this.basicDetailsForm.value.itemDes.trim();
      }
      const apiData = {
        collectionuuId: this.globalcollectionuuid,
        itemBankName: this.basicDetailsForm.value.itemTitle.trim(),
        itemDescription: this.basicDetailsForm.value.itemDes,
        itemBankId: this.itemUuid,
        ScoringTypeId: parseInt(this.basicDetailsForm.value?.scoringTypeId),
        StyleGroupId: parseInt(this.basicDetailsForm.value?.styleGroupId)

      };
      this.itemsSubscription = this.itemService.updateItem(apiData).subscribe(
        (resData) => {
          this.itemService.editedGetItem(resData);
          if (resData.data.scoringtypeid === ScoringTypeEnum.On180360Degree) {
            this.styleGroupSubscription$ = this.itemService.getStylesBasedOnStyleGroup(resData.data.itemuuId, resData.data.styleGroupid).subscribe(styles => {
              // this.StyleList = styles.data;
              this.itemService.StyleList.next(styles.data);
            },
            (error) => {this.styleGroupSubscription$.unsubscribe();});
          }
          sessionStorage.setItem("scoringTypeId", resData.data.scoringtypeid);
          this.itemService.ScoringTypeId.next(resData?.data?.scoringtypeid);
          this.notificationService.success(resData.message); // This line used to display message
          this.dialogRef.close();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn'); // This line used to display error message
          this.basicDetailsForm.controls['itemTitle'].reset()
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.itemsSubscription) {
      this.itemsSubscription.unsubscribe();
    }
    if (this.newItemSubscription) {
      this.newItemSubscription.unsubscribe();
    }
    // if (this.styleGroupSubscription$) {
    //   this.styleGroupSubscription.unsubscribe();
    // }
  }
}
